import React, { useState, useEffect } from "react";
import { useQueryClient } from "react-query";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
const EntityExpandedRow = ({
  data,
  handleEditEntity,
  dRLP1licensetype,
  setDRLP1licensetype,
  drlExpDate,
  licensetypes,
  setlicensetype,
  licensetype,
  drlp1Value,
  drlplicenseNumber,
  notes,
  comments,
  disregardedForTax,
}) => {
  const queryClient = useQueryClient();
  const [statesOptions, setStatesOptions] = useState([]);
  const [licenseTypeOptions, setlicenseTypeOptions] = useState([]);

  useEffect(() => {
    if (statesOptions.length === 0) {
      setStatesOptions(
        queryClient.getQueryData(["States"]).map((data) => {
          return { label: data.state, value: data.stateId };
        })
      );
    }

    if (licenseTypeOptions.length === 0) {
      setlicenseTypeOptions(
        queryClient.getQueryData(["LicenseTypes"]).map((data) => {
          return {
            label: data.licenseTypeName,
            value: data.licenseTypeName,
          };
        })
      );
    }
  }, [statesOptions, licenseTypeOptions]);
  return data.editRow ? (
    <div className="w-full shadow-md border-l-2 border-quinary">
      <div className="p-5 space-y-4 mb-2 ">
        <div className="text-xs text-secondary italic font-normal mb-3">
          <b>Note: </b> All fields with * are required to fill
        </div>
        <div className="text-xs font-medium -mx-2 ">
          <div className="grid  grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-6">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                License Type:
              </label>
              <div className="col-span-3">
                <SelectInput
                  options={licensetypes}
                  defaultValue={
                    licensetype
                      ? {
                          label: licensetype.label,
                          value: licensetype.label,
                        }
                      : { label: "", value: "" }
                  }
                  onChange={(selectedOptions) => {
                    setlicensetype(selectedOptions);
                    handleEditEntity(
                      "EditEntity",
                      "LicenseTypeID",
                      selectedOptions === null || "" ? 0 : selectedOptions.value
                    );
                  }}
                />
              </div>
            </div>
            <div className="grid grid-cols-6">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                DRLP1:
              </label>
              <div className="col-span-3">
                <TextInput
                  defaultValue={drlp1Value}
                  onBlur={(e) => {
                    handleEditEntity("EditEntity", "DRLP1", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="grid grid-cols-6">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                DRLP1 License Type:
              </label>
              <div className="col-span-3">
                <SelectInput
                  options={licenseTypeOptions}
                  defaultValue={
                    dRLP1licensetype
                      ? {
                          label: dRLP1licensetype.label,
                          value: dRLP1licensetype.label,
                        }
                      : { label: "", value: "" }
                  }
                  onChange={(selectedOptions) => {
                    setDRLP1licensetype(selectedOptions);
                    handleEditEntity(
                      "EditEntity",
                      "DRLP1LicenseType",
                      selectedOptions === null || "" ? 0 : selectedOptions.value
                    );
                  }}
                />
              </div>
            </div>
          </div>
          <div className="grid  grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-6 ">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                DRLP1 Expiration Date:
              </label>
              <div className="col-span-3">
                <TextInput
                  placeholder="DRLP1 Expiration Date"
                  value={drlExpDate === "" ? null : drlExpDate}
                  type="date"
                  onChange={(e) => {
                    handleEditEntity(
                      "EditEntity",
                      "DRLP1ExpDate",
                      e.target.value
                    );
                  }}
                />
              </div>
            </div>
            <div className="grid grid-cols-6">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                DRLP1 License Number:
              </label>
              <div className="col-span-3">
                <TextInput
                  defaultValue={drlplicenseNumber}
                  onBlur={(e) =>
                    handleEditEntity(
                      "EditEntity",
                      "DRLP1LicenseNumber",
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-6 ">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                Disregarded For Tax:
              </label>
              <div className="col-span-3">
                <TextInput
                  defaultValue={disregardedForTax}
                  onBlur={(e) =>
                    handleEditEntity(
                      "EditEntity",
                      "DisregardedForTax",
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          </div>
          {/* secondrow */}
          <div className="grid  grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-6">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                Comments:
              </label>
              <div className="col-span-3">
                <TextInput
                  defaultValue={comments}
                  onBlur={(e) =>
                    handleEditEntity("EditEntity", "Comments", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-6 ">
              <label className="col-span-2 block font-medium text-gray-700 my-1 text-left mr-2">
                Notes:
              </label>
              <div className="col-span-3">
                <TextInput
                  defaultValue={notes}
                  onBlur={(e) =>
                    handleEditEntity("EditEntity", "Notes", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="w-full">
      <div className="p-2 space-y-4 shadow-md border-l-2 border-primary mb-2">
        <div className="text-xs font-medium  border border-gray-200">
          <div className="grid  grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-6 w-full items-center gap-1">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2 ">
                License Type:{" "}
              </div>
              <div className="col-span-2 font-bold ">
                {licensetype?.label ? licensetype?.label : ""}
              </div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2 ">
                DRLP1:{" "}
              </div>
              <div className="col-span-3 font-bold ">
                {data.drlp1 ? data.drlp1 : ""}
              </div>
            </div>

            <div className="grid grid-cols-6 w-full items-center gap-1">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                DRLP1 License Type:{" "}
              </div>
              <div className="col-span-3 font-bold ">
                {data.drlp1licenseType === "0" ? "" : dRLP1licensetype?.label}
              </div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2 ">
                DRLP1 Expiration Date:{" "}
              </div>
              <div className="col-span-3 font-bold ">
                {data.drlp1expDate
                  ? (() => {
                      //Format date to mm/dd/yyyy
                      const [year, month, day] = data.drlp1expDate.split("-");
                      return `${parseInt(month)}/${parseInt(day)}/${year}`;
                    })()
                  : ""}
              </div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                DRLP1 License Number:{" "}
              </div>
              <div className="col-span-3 font-bold ">
                {" "}
                {data.drlp1licenseNumber ? data.drlp1licenseNumber : ""}
              </div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                Disregarded For Tax:{" "}
              </div>
              <div className="col-span-3 font-bold ">
                {data.disregardedForTax ? data.disregardedForTax : ""}
              </div>
            </div>
          </div>
          {/* secondrow */}
          <div className="grid  grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                Comments:
              </div>
              <div className="col-span-3 font-bold ">
                {data.comments ? data.comments : ""}
              </div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                Notes:
              </div>
              <div className="col-span-3 font-bold ">
                {data.notes ? data.notes : ""}
              </div>
            </div>

            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                Created Date:
              </div>
              <div className="col-span-3 font-bold ">
                {data.createdOn &&
                  new Date(data.createdOn).toLocaleDateString()}
              </div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                Created By:
              </div>
              <div className="col-span-3 font-bold ">{data.createdBy}</div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                Modified Date:
              </div>
              <div className="col-span-3 font-bold ">
                {data.updatedOn &&
                  new Date(data.updatedOn).toLocaleDateString()}
              </div>
            </div>
            <div className="grid grid-cols-6 w-full items-center gap-1 ">
              <div className="col-span-2 text-xs text-gray-700 text-left mr-2">
                Modified By:
              </div>
              <div className="col-span-3 font-bold ">{data.updatedBy}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntityExpandedRow;
